// extracted by mini-css-extract-plugin
export default {"activityList":"ActivityList-module__activityList--NkE9X","dataTable":"ActivityList-module__dataTable--CekO6","noActivity":"ActivityList-module__noActivity--IlvXe"};